import React, { useState } from 'react';
import { requestWithdrawal } from '../../services/paymentService';

interface WithdrawModalProps {
  onClose: () => void;
}

export default function WithdrawModal({ onClose }: WithdrawModalProps) {
  const [amount, setAmount] = useState('');
  const [toAddress, setToAddress] = useState('');
  const [txHash, setTxHash] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleWithdraw = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    const ethAmount = parseFloat(amount);
    if (!ethAmount || ethAmount <= 0) {
      setError('Please enter a valid amount.');
      return;
    }
    if (!toAddress.startsWith('0x') || toAddress.length !== 42) {
      setError('Please enter a valid Ethereum address.');
      return;
    }
    setLoading(true);
    try {
      const result = await requestWithdrawal({ amount: ethAmount, toAddress });
      setTxHash(result.transactionHash);
    } catch (err: any) {
      setError(err.message || 'Withdrawal failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (txHash) {
    return (
      <div className="modal-overlay" role="dialog" aria-modal="true">
        <div className="modal-box">
          <button className="modal-close" onClick={onClose} aria-label="Close">✕</button>
          <h2 className="modal-title">✅ Withdrawal Submitted</h2>
          <p className="modal-success-msg">
            Your withdrawal is being processed. Status: <strong>pending</strong>
          </p>
          <div className="tx-hash-box">
            <span className="tx-hash-label">Transaction Hash:</span>
            <span className="tx-hash-val">{txHash}</span>
          </div>
          <button className="btn-primary" onClick={onClose}>Done</button>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-label="Withdraw">
      <div className="modal-box">
        <button className="modal-close" onClick={onClose} aria-label="Close">✕</button>
        <h2 className="modal-title">🏦 Withdraw Funds</h2>

        {error && <div className="modal-error">{error}</div>}

        <form onSubmit={handleWithdraw} className="auth-form">
          <label className="auth-label">
            Amount (ETH)
            <input
              type="number"
              className="auth-input"
              value={amount}
              onChange={e => setAmount(e.target.value)}
              min="0"
              step="0.0001"
              placeholder="0.01"
              required
            />
          </label>
          <label className="auth-label">
            Destination Wallet Address
            <input
              type="text"
              className="auth-input"
              value={toAddress}
              onChange={e => setToAddress(e.target.value)}
              placeholder="0x..."
              required
            />
          </label>
          <p className="deposit-note">
            Withdrawals are processed on the Sepolia testnet. Gas fees will apply.
          </p>
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Processing…' : 'Withdraw'}
          </button>
        </form>
      </div>
    </div>
  );
}
